import { Minus, Plus } from "lucide-react";
import { haptic } from "../lib/telegram";

interface Props {
  value: number;
  min?: number;
  max: number;
  onChange: (quantity: number) => void;
  disabled?: boolean;
}

/** «− n +» в пределах [min, max]; max — лимит на вариант из товара. */
export function QtyStepper({ value, min = 1, max, onChange, disabled }: Props) {
  const step = (delta: number) => {
    haptic();
    onChange(Math.min(max, Math.max(min, value + delta)));
  };

  return (
    <div className="stepper">
      <button type="button" onClick={() => step(-1)} disabled={disabled || value <= min} aria-label="Убрать один">
        <Minus size={16} strokeWidth={2.2} aria-hidden />
      </button>
      <span className="stepper__value">{value}</span>
      <button type="button" onClick={() => step(1)} disabled={disabled || value >= max} aria-label="Добавить один">
        <Plus size={16} strokeWidth={2.2} aria-hidden />
      </button>
    </div>
  );
}
